import {
  PDF_MIME_TYPES,
  WORD_MIME_TYPES,
} from "@vega-core/constants/documents";

export const NDA_ACCEPT_MIME_TYPES = Object.keys({
  ...PDF_MIME_TYPES,
  ...WORD_MIME_TYPES,
}).join(",");
